// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"castle-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 4C14.7614 4 17 6.23858 17 9V21H7V9C7 6.23858 9.23858 4 12 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M22 21V14C22 11.7909 20.2091 10 18 10H17V21H22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M2 21H7V10H6C3.79086 10 2 11.7909 2 14V21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 21V16M22 14V21H17V10H18C20.2091 10 22 11.7909 22 14ZM7 21H2V14C2 11.7909 3.79086 10 6 10H7V21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 4C9.23858 4 7 6.23858 7 9H17C17 6.23858 14.7614 4 12 4ZM12 4V3M7 9.85V21H17V9.85","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-castle-2')
export default class Castle2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-2',
    }
  }
}
